import { createStyles, makeUiStyles, Theme } from '../styles/styles';
import { StylesIndexInjections } from 'common-react';

export default makeUiStyles((theme: Theme) => createStyles({
  root: {
    width: '100%',
    marginTop: 24,
    '&$rootCreatorFundDetails': {
      marginTop: 0,
      display: 'flex',
      justifyContent: 'center',
      position: 'relative',
    },
    [theme.breakpoints.down('sm')]: {
      marginTop: 4,
      padding: '0 16px',
    },
  },
  appbar: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',

    backgroundColor: theme.color.greys[0],
    boxShadow: 'none',
    height: theme.space.headerMobileHeight,
    padding: '0 16px 0 24px',
    maxWidth: theme.space.basicDataMaxWidth,
    margin: '0 auto',
    borderRadius: 16,
    [theme.breakpoints.down('sm')]: {
      border: `1px solid ${theme.color.greys[15]}`,
      padding: '0px 8px 0px 16px',
    },
    '&$appBarCreatorFundDetails': {
      position: 'absolute',
      top: 24,
      zIndex: theme.zIndex.appBar,
      [theme.breakpoints.up('md')]: {
        backgroundColor: theme.color.greys[0],
        maxWidth: theme.space.fundDetailsMaxWidthDefault,
        margin: '0 auto',
      },
      [theme.breakpoints.down('sm')]: {
        top: 4,
        maxWidth: 'calc(100% - 32px)',
      }
    },
  },
  logoBox: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  link: {
    padding: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  innerNav: {
    display: 'flex',
    margin: '0 0 0 auto',
  },
  appBarCreatorFundDetails: {},
  rootCreatorFundDetails: {},
}), { name: 'Header', index: StylesIndexInjections.UI_MOLECULES });
